import React, { Fragment, useEffect, useState } from "react";

import { Transition } from "@headlessui/react";
import { IoIosArrowBack } from "react-icons/io";
import { useLocation } from "react-router-dom";
import DaffiUserRegister from "views/components/auth/register/DaffiUserRegister";
import LocalUserRegister from "views/components/auth/register/LocalUserRegister";

const Register = (props) => {
	const location = useLocation();

	const [registrationType, setRegistrationType] = useState(null);

	useEffect(() => {
		if (location && location.state) {
			const { registrationType } = location.state;

			setRegistrationType(registrationType);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		registrationType && (
			<Transition
				as={Fragment}
				appear={true}
				show={true}
				enter="transition-opacity duration-500"
				enterFrom="opacity-0"
				enterTo="opacity-100"
				leave="transition-opacity duration-250"
				leaveFrom="opacity-100"
				leaveTo="opacity-0"
			>
				<div className="h-screen flex items-center justify-center">
					{/* <div className="flex flex-col w-[50%] items-center justify-center space-y-10 px-14">
						{registrationType === "daffi" ? (
							<div className="flex flex-col w-full items-center justify-center">
								<div className="flex-col text-start justify-start space-y-3">
									<p className="text-sm font-bold text-dark-blue">
										Your Daffi Account will assist you If you wish to be able to install your Daffi
										<span className="italic">Wallet</span> on multiple devices or reinstall at a later date.
									</p>
									<div className="flex flex-col">
										<p className="text-sm italic text-dark-blue">
											The Daffi
											<span className="italic">Wallet</span> information stored in your Daffi User Account
											consist of:
										</p>
										<ul className="list-disc pl-7 text-sm italic text-dark-blue">
											<li>Your Profile information</li>
											<li>Your Contacts information</li>
											<li>
												Your Accounts information, excluding your Secret Words which you will be required
												to enter for the account to allow transaction, if not the account the account will
												only allow a Read mode
											</li>
											<li>Your Settings</li>
										</ul>
									</div>
								</div>
								<IoIosArrowBack
									className="text-4xl text-dark-blue cursor-pointer"
									onClick={() => props.navigatePage(-1)}
								/>
							</div>
						) : (
							<div className="flex flex-col w-full items-center justify-center space-y-4">
								<div className="flex-col text-start justify-start space-y-3">
									<p className="text-sm font-bold text-dark-blue">
										If you wish to be able to reinstall your Daffi
										<span className="italic">Wallet</span> on multiple devices or reinstall at a later date.
									</p>
									<div className="flex flex-col">
										<p className="text-sm italic text-dark-blue">
											The Daffi
											<span className="italic">Wallet</span> information stored in your Daffi User Account
											consist of:
										</p>
										<ul className="list-disc pl-7 text-sm italic text-dark-blue">
											<li>Your Profile information</li>
											<li>Your Contacts information</li>
											<li>
												Your Accounts information,excluding your Secret Words which you will be required
												to enter for the account to allow transaction, if not the account the account will
												only allow a Read mode
											</li>
											<li>Your Settings</li>
										</ul>
									</div>
								</div>
								<div className="flex-col text-start justify-start space-y-3">
									<p className="text-sm font-bold text-dark-blue">
										Additionally, if you were to loose your device, from any other device, on which your Daffi
										<span className="italic">Wallet</span> is installed and linked to your Daffi
										<span className="italic">Wallet</span> User Account, you can wipe out the content of the
										Daffi
										<span className="italic">Wallet</span> that is installed on your lost or stolen device.
									</p>
									<p className="text-sm font-bold text-dark-blue">
										Creating a Daffi User Account is optional, you can use all the functionalities of the
										Daffi
										<span className="italic">Wallet</span> without create a Daffi User Account
									</p>
								</div>
								<IoIosArrowBack
									className="text-4xl text-dark-blue cursor-pointer"
									onClick={() => props.navigatePage(-1)}
								/>
							</div>
						)}
					</div> */}
					<div className="flex flex-col w-[50%] items-center justify-center space-y-10 px-14">
						{registrationType === "daffi" ? (
							<DaffiUserRegister {...props} registrationType={registrationType} />
						) : (
							<>
								<LocalUserRegister {...props} registrationType={registrationType} />
								<IoIosArrowBack
									className="text-4xl text-dark-blue cursor-pointer"
									onClick={() => props.navigatePage(-1)}
								/>
							</>
						)}
					</div>
				</div>
			</Transition>
		)
	);
};

export default Register;
